import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="sidebar"
export default class extends Controller {
  connect() {
    this.toggleButton = document.getElementById('filterButton');
    this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this));
  }

  toggleSidebar() {
    this.element.classList.toggle('hidden');
  }
}
